// extracted by mini-css-extract-plugin
export default {"helpIcon":"HelpNavigation_helpIcon__UiGIW","menuIcon":"HelpNavigation_menuIcon__1wnj+","navigationText":"HelpNavigation_navigationText__hf4fQ"};